import React from 'react';
import { Link } from 'react-router-dom';

const segments = [
  {
    title: 'Home & Furniture',
    description: 'Furniture, storage, décor and everyday home essentials.',
    searchTerm: 'home furniture',
  },
  {
    title: 'Kitchen & Dining',
    description: 'Cookware, appliances, dining products and kitchen essentials.',
    searchTerm: 'kitchen dining',
  },
  {
    title: 'Home Improvement',
    description: 'Tools, lighting, fittings, hardware and improvement products.',
    searchTerm: 'home improvement',
  },
  {
    title: 'Décor & Lifestyle',
    description: 'Interior products and everyday lifestyle essentials.',
    searchTerm: 'home decor',
  },
  {
    title: 'Electronics & Appliances',
    description: 'Selected electronics and appliances for modern living.',
    searchTerm: 'home appliances',
  },
  {
    title: 'Outdoor & Living',
    description: 'Garden, outdoor, leisure and connected living products.',
    searchTerm: 'outdoor garden',
  },
  {
    title: 'Business & Hospitality',
    description: 'Products for commercial, hospitality and institutional needs.',
    searchTerm: 'hotel supplies',
  },
];

const CuratedSegments = () => {
  return (
    <section className="py-16 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-green-700 mb-2">
            Explore Home & Lifestyle
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {segments.map((segment, index) => (
            <Link
              key={segment.title}
              to={`/products?search=${encodeURIComponent(segment.searchTerm)}`}
              className="cursor-pointer bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-300 p-6 h-full"
            >
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-green-100 text-green-700 font-bold text-sm mb-4">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{segment.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{segment.description}</p>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/products"
            className="cursor-pointer inline-flex items-center justify-center bg-green-600 text-white font-semibold px-6 py-3 rounded-md hover:bg-green-700 hover:scale-105 transition-all duration-300"
          >
            Explore Categories
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CuratedSegments;
